import { SideBarLink } from "utils/types/links";
import SvgData from "assets/svgs";
import {
  Dropdown,
  DropdownTrigger,
  DropdownMenu,
  DropdownItem,
  Button,
  Chip,
  Badge,
} from "@nextui-org/react";
import { classNames } from "utils/helper/helper";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectOrderPendingCount } from "store/order/order.selector";

function SidebarItem({ item }: { item: SideBarLink }) {
  const location = useLocation();
  const navigate = useNavigate();
  const path = location.pathname;
  const pendingCount = useSelector(selectOrderPendingCount);
  const _isActive =
      item.uri != null
        ? path.startsWith(item.uri)
        : item.for != null && path.startsWith(item.for),
    isActive =
      item.uri === "/dashboard"
        ? path === "/dashboard"
        : item.uri != null && item.uri === "/"
        ? item.uri === path
        : _isActive,
    childItems = item.children?.map((link, i) => ({
      ...link,
      key: i,
      label: link.title,
    }));

  return (
    <li
      className={classNames(
        isActive
          ? "text-secondary-400 dark:text-dark-border"
          : "text-base-color dark:text-white",
        "group-[.sidebar-size-sm]:flex group-[.sidebar-size-sm]:justify-center group-[.sidebar-size-sm]:items-center"
      )}
    >
      {item.children == null && (
        <Link
          to={item.uri!}
          className={classNames(
            isActive ? "bg-secondary-400 text-dark-base" : "",
            "group-[.sidebar-size-sm]:px-2 group-[.sidebar-size-sm]:flex group-[.sidebar-size-sm]:justify-center"
          )}
        >
          <SvgData
            name={item.icon}
            className={classNames(
              "w-6 h-6",
              item.icon === "orders" ? "group-[.sidebar-size-sm]:hidden" : ""
            )}
          />
          {item.icon === "orders" && (
            <Badge
              color="primary"
              content={pendingCount}
              className="group-[.sidebar-size-sm]:flex hidden"
              classNames={{
                base: "group-[.sidebar-size-sm]:flex hidden",
              }}
            >
              <SvgData
                name={item.icon}
                className="w-6 h-6 group-[.sidebar-size-sm]:flex hidden"
              />
            </Badge>
          )}
          <span className="group-[.sidebar-size-sm]:hidden">{item.title}</span>
          {item.icon === "orders" && (
            <Chip
              color="primary"
              size="sm"
              className="w-5 h-5 group-[.sidebar-size-sm]:hidden"
            >
              {pendingCount}
            </Chip>
          )}
        </Link>
      )}
      {item.children != null && (
        <>
          <details open={isActive} className="group-[.sidebar-size-sm]:hidden">
            <summary
              className={
                isActive
                  ? "bg-light text-secondary-400 dark:text-dark-base"
                  : ""
              }
            >
              <SvgData name={item.icon} className="w-6 h-6" />
              <span>{item.title}</span>
            </summary>
            <ul className="space-y-1.5 mt-2">
              {item.children.map((child, i) => (
                <li key={i}>
                  <Link
                    to={child.uri}
                    className={
                      path === child.uri
                        ? "bg-secondary-400 hover:bg-secondary-500 text-dark-base"
                        : "text-base-color dark:text-white"
                    }
                  >
                    {child.title}
                  </Link>
                </li>
              ))}
            </ul>
          </details>

          <Dropdown>
            <DropdownTrigger>
              <Button
                isIconOnly
                variant="light"
                className={classNames(
                  isActive
                    ? "bg-light text-secondary-400 dark:text-dark-base"
                    : "text-base-color dark:text-white",
                  "hidden group-[.sidebar-size-sm]:flex"
                )}
              >
                <SvgData name={item.icon} className="w-6 h-6" />
              </Button>
            </DropdownTrigger>
            <DropdownMenu aria-label="Dynamic Actions" items={childItems}>
              {(child) => (
                <DropdownItem
                  key={child.key}
                  color={path === child.uri ? "secondary" : "default"}
                  onPress={() => navigate(child.uri)}
                  className={
                    path === child.uri
                      ? "bg-secondary-400 hover:bg-secondary-500 text-dark-base"
                      : "text-base-color dark:text-white"
                  }
                >
                  {child.label}
                </DropdownItem>
              )}
            </DropdownMenu>
          </Dropdown>
        </>
      )}
    </li>
  );
}

export default SidebarItem;
